import React from 'react';

export default function DashboardPA({
  dashboardStats,
  cohorts,
  sessions,
  reports,
  auditors,
  groupedSessionsActive,
  handleStartCohortWizard,
  handleStartSessionForm,
  handleStartSessionEdit,
  handleNavigate,
  setActiveTab,
  setSelectedCohort,
  setCohortDetailTab,
}) {
  // Needs Assignment: only planned|live still needing auditor or counselor.
  // Allowlist (not denylist) so Cancelled/Completed never appear (BUG-mentor-needs-assignment-cancelled-01).
  const unassignedSessions = sessions.filter((s) => {
    const status = String(s.status || '').toLowerCase();
    return ['planned', 'live'].includes(status)
      && ((s.auditors || []).length === 0 || !s.counselorId);
  });
  return (
    <div>
      <div className="dashboard-title-row animate-fade-in">
        <div>
          <h1 className="dashboard-title">PA Operations Dashboard</h1>
          <p className="dashboard-subtitle">Review active Glosco cohorts, scheduled sessions, and auditor pools.</p>
        </div>
        <div className="dashboard-actions-row">
          <button className="btn-create-cohort" onClick={handleStartCohortWizard}>
            Create Cohort
          </button>
        </div>
      </div>

      <div className="dashboard-stats-grid">
        <div className="dashboard-stat-card" data-testid="dashboard-stat-cohorts">
          <div className="stat-header">
            <span className="stat-title">Total Cohorts</span>
            <span className="stat-icon">👥</span>
          </div>
          <div className="stat-value">{dashboardStats.cohortsCount}</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '8px' }}>
            {cohorts.filter(c => c.status === 'Active').length} active
          </div>
        </div>

        <div className="dashboard-stat-card" data-testid="dashboard-stat-active-sessions">
          <div className="stat-header">
            <span className="stat-title">Active Sessions</span>
            <span className="stat-icon">📅</span>
          </div>
          <div className="stat-value">{dashboardStats.activeSessionsCount}</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '8px' }}>
            {sessions.filter(s => s.status === 'Live').length} live now
          </div>
        </div>

        <div className="dashboard-stat-card orange" style={{ cursor: 'pointer' }} onClick={() => handleNavigate('approvals')}>
          <div className="stat-header">
            <span className="stat-title">Year 1 Auditor Evaluation</span>
            <span className="stat-icon">⚠️</span>
          </div>
          <div className="stat-value" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span>{dashboardStats.pendingApprovalsCount}</span>
            {dashboardStats.pendingApprovalsCount > 0 && (
              <span className="stat-pending-badge">Action Required</span>
            )}
          </div>
          <div style={{ fontSize: '12px', color: 'var(--accent-orange)', marginTop: '8px', fontWeight: 600 }}>
            Click to review →
          </div>
        </div>

        <div className="dashboard-stat-card">
          <div className="stat-header">
            <span className="stat-title">Auditors Pool</span>
            <span className="stat-icon">🔍</span>
          </div>
          <div className="stat-value">{dashboardStats.auditorsCount}</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '8px' }}>
            across all cohorts
          </div>
        </div>
      </div>

      {unassignedSessions.length > 0 && (
        <div style={{ marginBottom: '28px' }}>
          <div className="section-header">
            <h2 className="section-title" style={{ color: '#b45309' }}>⚠️ Needs Assignment ({unassignedSessions.length})</h2>
            <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-muted)' }}>Sessions missing an auditor or counselor — assign before they go live.</p>
          </div>
          <div className="timeline-grid" style={{ marginTop: '12px' }}>
            {unassignedSessions.map(session => (
              <div
                key={session.id}
                className="timeline-session-card clickable-card"
                style={{ borderLeft: '4px solid #f59e0b', cursor: 'pointer' }}
                onClick={() => handleStartSessionEdit(session)}
                title="Click to assign auditor / counselor"
              >
                <div className="session-card-header">
                  <div>
                    <span className="session-card-type">{session.sessionType}</span>
                    <h3 style={{ margin: '4px 0 2px', fontSize: '13px', fontWeight: 'bold' }}>{session.cohortName}</h3>
                    <p style={{ margin: 0, fontSize: '11px', color: 'var(--text-muted)' }}>🏫 {session.schoolName}</p>
                  </div>
                  <span className={`status-pill ${session.status.toLowerCase()}`}>{session.status}</span>
                </div>
                <div className="session-card-meta" style={{ marginTop: '10px', fontSize: '12px' }}>
                  <div>📅 {session.scheduledAt.split(/[T ]/)[0]}</div>
                  <div style={{ marginTop: '2px' }}>🕒 {session.timeSlot}</div>
                </div>
                <div style={{ marginTop: '10px', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {session.auditors.length === 0 && (
                    <span style={{ fontSize: '11px', background: '#fef3c7', color: '#b45309', padding: '2px 8px', borderRadius: '999px', fontWeight: 600 }}>No Auditor</span>
                  )}
                  {!session.counselorId && (
                    <span style={{ fontSize: '11px', background: '#e0e7ff', color: '#3730a3', padding: '2px 8px', borderRadius: '999px', fontWeight: 600 }}>No Counselor</span>
                  )}
                </div>
                <div className="session-card-view-hint" style={{ marginTop: '8px' }}>Click to assign →</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="dashboard-grid animate-fade-in">
        <div className="dashboard-main-col">
          <div className="section-header">
              <h2 className="section-title">📅 Year 1 Fellowship Audits</h2>
          </div>

          {Object.keys(groupedSessionsActive).length > 0 ? (
            Object.keys(groupedSessionsActive).map(weekLabel => (
              <div key={weekLabel} className="timeline-week-group">
                <div className="timeline-week-header">
                  <span>{weekLabel}</span>
                  <button
                    className="btn-week-plan-session"
                    onClick={() => handleStartSessionForm('')}
                  >
                    + Plan Session
                  </button>
                </div>

                <div className="timeline-grid">
                  {groupedSessionsActive[weekLabel].map(session => {
                    const cohort = cohorts.find(c => c.id === session.cohortId);
                    return (
                      <div
                        key={session.id}
                        className="timeline-session-card clickable-card"
                        onClick={() => {
                          if (cohort) {
                            setActiveTab('cohorts');
                            setSelectedCohort(cohort);
                            setCohortDetailTab('sessions');
                            window.location.hash = `#/cohorts/${cohort.id}/sessions`;
                          }
                        }}
                        title={`View ${session.cohortName} sessions`}
                      >
                        <div className="session-card-header">
                          <div>
                            <span className="session-card-type">{session.sessionType}</span>
                            <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
                              {session.scheduledAt.split(/[T ]/)[0]}
                            </div>
                          </div>
                          <span className={`status-pill ${session.status.toLowerCase()}`}>{session.status}</span>
                        </div>

                        <div className="session-card-meta">
                          <div>🏫 School: <strong>{session.schoolName}</strong></div>
                          <div style={{ marginTop: '2px' }}>👥 Cohort: <strong>{session.cohortName}</strong></div>
                          <div style={{ marginTop: '2px' }}>🕒 Slot: <strong>{session.timeSlot}</strong></div>
                          <div style={{ marginTop: '4px' }}>🔗 Zoom: <a href={session.meetingLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }} onClick={e => e.stopPropagation()}>Join Room</a></div>
                        </div>

                        <div className="session-card-footer">
                          <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>Auditors:</span>
                          <div className="session-card-auditors">
                            {session.auditors.map(audId => {
                              const aud = auditors.find(a => a.id === audId);
                              const assignmentObj = cohort?.auditorAssignments?.find(a => a.auditorId === audId);
                              const isStandby = assignmentObj ? assignmentObj.isStandby : false;
                              return (
                                <span key={audId} className={`auditor-avatar-pill ${isStandby ? 'standby' : ''}`}>
                                  {aud ? aud.name : 'Auditor'} {isStandby ? '(S)' : ''}
                                </span>
                              );
                            })}
                          </div>
                        </div>

                        <div className="session-card-view-hint">View cohort sessions →</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state-card" style={{ borderStyle: 'solid', padding: '40px' }}>
              <div className="empty-state-icon-wrapper" style={{ width: '60px', height: '60px', fontSize: '24px' }}>
                <span>📅</span>
              </div>
              <h3 className="empty-state-heading" style={{ fontSize: '16px' }}>No active upcoming sessions</h3>
              <p className="empty-state-description" style={{ fontSize: '13px' }}>
                Create a cohort and schedule orientaion or council audits to plan fellowship sessions.
              </p>
            </div>
          )}
        </div>

        <div className="dashboard-side-col">
          <div>
            <div className="section-header">
              <h2 className="section-title">👥 Active Cohorts</h2>
            </div>
            <div className="dashboard-list-card cohorts-stack">
              {cohorts.map(c => (
                <div
                  key={c.id}
                  className="cohort-row-item"
                  onClick={() => {
                    setActiveTab('cohorts');
                    setSelectedCohort(c);
                    setCohortDetailTab('students');
                    window.location.hash = `#/cohorts/${c.id}/students`;
                  }}
                >
                  <div className="cohort-row-info">
                    <span className="cohort-row-name">{c.name}</span>
                    <span className="cohort-row-subtext">{c.schoolName} • {c.studentIds.length} Students</span>
                  </div>
                  <span className="status-pill active">{c.status}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="section-header">
              <h2 className="section-title">✓ Year 1 Evaluation Approvals Queue</h2>
            </div>
            <div className="dashboard-list-card approvals-stack">
              {reports.map(rep => (
                <div key={rep.id} className="approval-row-item">
                  <div className="approval-info">
                    <span className="approval-title">{rep.title}</span>
                    <span className="approval-meta">{rep.school} • Submitted {rep.submittedAt}</span>
                  </div>
                  <span className={`approval-status-badge ${rep.status}`}>
                    {rep.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
